(function() {
  document.addEventListener("DOMContentLoaded", function() {
    var CookieBotClass = {
      classes: {
        RENEW_LINK: ".cookieconsent-js"
      },
      init: function() {
        var cookieEnableLinks = document.querySelectorAll(
          this.classes.RENEW_LINK
        );

        if (cookieEnableLinks.length > 0) {
          Array.prototype.forEach.call(
            cookieEnableLinks,
            function(element) {
              element.addEventListener(
                "click",
                function() {
                  if (typeof Cookiebot !== "undefined") {
                    Cookiebot.renew();
                  }
                }.bind(this)
              );
            }.bind(this)
          );
        }
      }
    };

    CookieBotClass.init();
  });
})();
